export const CRAMO_CONFIRM_CONFIG = {
	width: '400px',
	height: 'auto',
	maxWidth: '90vw',
	maxHeight: '80vh',
	restoreFocus: false,
};
